import { render, staticRenderFns } from "./IndustryApplication.vue?vue&type=template&id=f1a221ea&scoped=true&"
import script from "./IndustryApplication.vue?vue&type=script&lang=js&"
export * from "./IndustryApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a221ea",
  null
  
)

export default component.exports